import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import MainLayout from '../components/layout/MainLayout';
import { webAppConfig } from '../config/appConfig';

export default function HomePage() {
  const logoSrc = webAppConfig.brand.logoPath;

  return (
    <MainLayout
      className="landing-shell"
      header={(
        <Header
          className="landing-header"
          brandHref={webAppConfig.routes.home}
          logoSrc={logoSrc}
          brandText={webAppConfig.brand.name}
          brandClassName="landing-brand"
          logoClassName="landing-brand-logo"
          brandTextClassName="landing-brand-name"
          variant="landing"
        />
      )}
      footer={(
        <Footer className="landing-footer" variant="landing" />
      )}
    >
      <main>
      <section id="home" className="landing-hero" aria-labelledby="home-title">
        <div className="landing-hero-glow" aria-hidden="true" />
        <div className="landing-hero-layout">
          <div className="landing-hero-content premium">
            <p className="landing-kicker">On-demand task marketplace</p>
            <h1 id="home-title">Find trusted local help fast. Or get paid for your skills.</h1>
            <p>
              {webAppConfig.brand.name} helps businesses and workers connect in minutes through location-first matching,
              smart alerts, and transparent ratings.
            </p>
            <div className="landing-cta-row">
              <Link to={webAppConfig.routes.app} className="landing-btn-primary" aria-label="Post a task as business">Post a Task</Link>
              <Link to={webAppConfig.routes.app} className="landing-btn-secondary" aria-label="Find jobs as worker">Find Work</Link>
            </div>
          </div>
        </div>
      </section>

      <section id="how" className="landing-section" aria-labelledby="how-title">
        <h2 id="how-title">How it works</h2>
        <div className="landing-step-grid">
          <article className="landing-step-card">
            <span className="landing-step-icon">1</span>
            <h3>Post a task</h3>
            <p>Share what you need, budget, and location in seconds.</p>
          </article>
          <article className="landing-step-card">
            <span className="landing-step-icon">2</span>
            <h3>Workers get notified</h3>
            <p>Relevant nearby workers receive smart instant alerts.</p>
          </article>
          <article className="landing-step-card">
            <span className="landing-step-icon">3</span>
            <h3>First to accept gets the job</h3>
            <p>Move from posting to productivity in record time.</p>
          </article>
        </div>
      </section>

      <section id="features" className="landing-section" aria-labelledby="features-title">
        <h2 id="features-title">Feature highlights</h2>
        <div className="landing-feature-grid">
          <article className="landing-feature-card"><h3>Smart Notifications</h3><p>Workers get instant role-based alerts.</p></article>
          <article className="landing-feature-card"><h3>Ratings & Reviews</h3><p>Trust-first marketplace with transparent feedback.</p></article>
          <article className="landing-feature-card"><h3>Skill Matching</h3><p>Better-fit matches by role, skills, and distance.</p></article>
          <article className="landing-feature-card"><h3>Schedule Sync</h3><p>Keep tasks organized with real-time timeline updates.</p></article>
        </div>
      </section>
      
      {/* <section id="trust" className="landing-section">
        <h2>Trusted by growing teams and workers</h2>
        <div className="landing-testimonial-grid">
          <article className="landing-testimonial-card">
            <p>“We filled last-minute shifts in under an hour. Huge operational win.”</p>
            <span>— Operations Manager</span>
          </article>
          <article className="landing-testimonial-card">
            <p>“I can pick up jobs around classes and get paid fast. Perfect flexibility.”</p>
            <span>— Student Worker</span>
          </article>
          <article className="landing-testimonial-card">
            <p>“The platform gives us confidence with clear reviews and transparent rates.”</p>
            <span>— Local Business Owner</span>
          </article>
        </div>
      </section> */}

      <section id="cta" className="landing-section landing-final-cta" aria-labelledby="cta-title">
        <h2 id="cta-title">Ready to get started?</h2>
        <p>Fastest way to connect work with workers — with less friction and better outcomes.</p>
        <div className="landing-cta-row">
          <Link to={webAppConfig.routes.app} className="landing-btn-primary">Post a Task</Link>
          <Link to={webAppConfig.routes.app} className="landing-btn-secondary">Find Work</Link>
        </div>
      </section>
      </main>
    </MainLayout>
  );
}
